import { ENDPOINTS } from 'src/constants/endpoints'

import type { IPortfolioNewsDetailDTO } from 'src/app/home/pages/portfolio-news/domain/contracts/portfolio-news'
import { http } from 'src/interfaces/http'

export const getPortfolioNewsDetail = async (
  articleId: string,
): Promise<IPortfolioNewsDetailDTO> => {
  const { data } = await http.get<IPortfolioNewsDetailDTO>(
    ENDPOINTS.hanwha.portfolioNewsDetail(articleId),
  )
  return data
}
